export const getPureBase64 = (b64Data) => b64Data.substr(b64Data.indexOf(',') + 1);
export const decodeBase64 = (b64Data) => atob(getPureBase64(b64Data));
export const base64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = decodeBase64(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
};
export const base64toArrayBuffer = (b64Data) => Uint8Array.from(decodeBase64(b64Data), (c) => c.charCodeAt(0));
